import * as React from 'react';
import {
    ShimmerElementsGroup,
    ShimmerElementType as ElemType,
    Shimmer,
    IShimmerStyles,
    IShimmerProps,
} from 'office-ui-fabric-react/lib/Shimmer';

const styles = require('./AgendaEventsLoadingListView.scss');
const numShimmerElements = 8;

const totalHeight = 64;

const firstBlockWidth = 32;
const secondBlockWidth = 65;
const thirdBlockWidth = 139;

export interface AgendaEventsLoadingListViewProps {
    isDataLoaded: boolean;
    className?: string;
}

export const AgendaEventsLoadingListView: React.StatelessComponent<
    AgendaEventsLoadingListViewProps
> = props => {
    let shimmerElements: JSX.Element[] = [];
    for (let i = 0; i < numShimmerElements; i++) {
        shimmerElements.push(renderShimmerItem(i));
    }

    return (
        <Shimmer
            className={props.className}
            styles={getShimmerStyles}
            customElementsGroup={shimmerElements}
            width={firstBlockWidth + secondBlockWidth + thirdBlockWidth}
            height={totalHeight}
            isDataLoaded={props.isDataLoaded}>
            {props.children}
        </Shimmer>
    );
};

function renderShimmerItem(keyIndex: number): JSX.Element {
    return (
        <div className={styles.shimmerItemWrapper} key={'agendaEventsLoadingView_' + keyIndex}>
            <ShimmerElementsGroup
                shimmerElements={[
                    { type: ElemType.gap, width: firstBlockWidth / 2, height: totalHeight },
                    { type: ElemType.line, width: 6, height: 46 },
                    {
                        type: ElemType.gap,
                        width: 10 /* firstBlockWidth / 2 - the line width */,
                        height: totalHeight,
                    },
                ]}
            />
            <ShimmerElementsGroup
                flexWrap={true}
                width={'65px'}
                shimmerElements={[
                    { type: ElemType.gap, width: secondBlockWidth, height: totalHeight / 4 },
                    { type: ElemType.line, width: 37, height: 10 },
                    {
                        type: ElemType.gap,
                        width: 28 /* secondBlockWidth - line width */,
                        height: totalHeight / 4,
                    },
                    { type: ElemType.gap, width: secondBlockWidth, height: totalHeight / 4 },
                    { type: ElemType.gap, width: secondBlockWidth, height: totalHeight / 4 },
                ]}
            />
            <ShimmerElementsGroup
                flexWrap={true}
                width={'139px'}
                shimmerElements={[
                    { type: ElemType.gap, width: thirdBlockWidth, height: totalHeight / 4 },
                    { type: ElemType.line, width: thirdBlockWidth, height: 10 },
                    { type: ElemType.line, width: 84, height: 10 },
                    {
                        type: ElemType.gap,
                        width: 55 /* thirdBlockWidth - line width */,
                        height: totalHeight / 4,
                    },
                    { type: ElemType.gap, width: thirdBlockWidth, height: totalHeight / 4 },
                ]}
            />
            <ShimmerElementsGroup
                width={'84px'}
                shimmerElements={[{ type: ElemType.gap, width: 84, height: 64 }]}
            />
        </div>
    );
}

function getShimmerStyles(props: IShimmerProps): IShimmerStyles {
    return {
        dataWrapper: {
            height: '100%',
        },
        shimmerWrapper: {
            maxHeight: totalHeight * numShimmerElements,
        },
    };
}
